exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    /* color: #108ee9; */\r\n    cursor: pointer;\r\n    width: 90%;\r\n    display: inline-block;\r\n}\r\n\r\n.link:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.data-cube {\r\n    position: relative;\r\n    background-color: #fff;\r\n    padding: 15px 30px;\r\n    border-radius: 5px;\r\n    margin: 30px 10px 0 10px;\r\n    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);\r\n    cursor: pointer;\r\n}\r\n\r\n.data-cube .number {\r\n    font-size: 36px;\r\n    line-height: 50px;\r\n}\r\n\r\n.data-cube .title {\r\n    margin-top: 10px;\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/home/home.component.css
// module id = ../../../../../src/app/home/components/home/home.component.css
// module chunks = main